module.exports = __webpack_public_path__ + "img/logo_ion.59ce669a.png";